"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignAttachment = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Represents an entry in the "campaign_attachments" table.
 */

/**
 * @deprecated - use the campaign attachment methods instead
 */
var CampaignAttachment = /*#__PURE__*/_createClass(function CampaignAttachment(data) {
  _classCallCheck(this, CampaignAttachment);

  _defineProperty(this, "id", null);

  _defineProperty(this, "name", null);

  _defineProperty(this, "file_name", null);

  _defineProperty(this, "file_url", null);

  _defineProperty(this, "attachment", null);

  _defineProperty(this, "visible", true);

  Object.assign(this, data);
});

exports.CampaignAttachment = CampaignAttachment;